var SCM = SCM || {};

SCM.ArticlesByType = (function ($) {

    var baseUrl;
    var widgetjournalId;
    var articleClientTypeId;

    return {
        init: init,
        handlePaginationClick: handlePaginationClick
    };

    function init() {
        if ($('.widget-ArticlesByTypeList').length) {
            var $widgetElement = $('.js-ArticlesByTypeList');

            baseUrl = SCM.Pagination.trimEndUntilRegexMatches(document.URL.valueOf(), '[a-zA-Z]$');
            widgetjournalId = $widgetElement.data('journal-id');
            articleClientTypeId = $widgetElement.data('article-type-id');

            SCM.Pagination.enableBrowserHistoryNavigation();
        }
    }

    function handlePaginationClick(jqElement) {
        SCM.Pagination.updateBrowseHistory(baseUrl, baseUrl);

        var ajaxSettings = {
            type: 'POST',
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') +
                '/Article/ArticlesByTypeList/' +
                jqElement.data('parent-instance'),
            cache: false,
            data: {
                journalId: widgetjournalId,
                page: jqElement.data('clicked-page'),
                articleClientType: articleClientTypeId
            }
        };

        SCM.Pagination.performAjaxPagination(ajaxSettings, jqElement);
    }


})(jQuery);

jQuery(function () {
    SCM.ArticlesByType.init();
});